import CellRenderer from './cells/CellRenderer';

export default function CardRowOverlay({ card, columns, groupColor, cardValues, statusOptions, users, titleColWidth }) {
  const totalWidth = titleColWidth + columns.reduce((s, c) => s + (c.width ?? 150), 0) + 40;

  return (
    <div
      className="flex items-center bg-card border border-accent/40 shadow-2xl rounded-sm overflow-hidden pointer-events-none"
      style={{ width: totalWidth, opacity: 0.96 }}
    >
      <div className="w-1.5 self-stretch shrink-0 min-h-[40px]" style={{ backgroundColor: groupColor }} />
      <div
        className="shrink-0 px-3 py-2 text-sm text-text-primary truncate"
        style={{ width: titleColWidth - 6 }}
      >
        {card.title}
      </div>
      {columns.map((col) => (
        <div
          key={col.id}
          className="shrink-0 border-l border-border/20 overflow-hidden"
          style={{ width: col.width ?? 150 }}
        >
          <CellRenderer
            column={col}
            card={card}
            value={cardValues[`${card.id}:${col.id}`] ?? null}
            onChange={() => {}}
            statusOptions={statusOptions[col.id]}
            users={users}
          />
        </div>
      ))}
      <div className="shrink-0" style={{ width: 40 }} />
    </div>
  );
}
